module.exports = __webpack_public_path__ + "img/security-new.a247ca7.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/security-new.jpg
// module id = ./assets/img/security-new.jpg
// module chunks = 9